import React from "react";
import Grid from "@mui/material/Grid";
import InstallationStateMonitoring
    from "../../Components/HomeMonitoring/InstallationStateMonitoring/InstallationStateMonitoring";
import TechnicalAlerts from "../../Components/HomeMonitoring/TechnicalAlerts/TechnicalAlerts";
import './Home.css';
import InstallationQuickDisplay
    from "../../Components/HomeMonitoring/InstallationQuickDisplay/InstallationQuickDisplay";
import {getDetailedAccounts} from "../../../graphql/queries";
import GraphQlTool from "../../../Utils/GraphQlTool";
import {TechnicalAlertIdentifier} from "../../../Utils/TechnicalAlertIdentifier";

let instanceHome;

/**
 * Vue d'accueil : suit les installations, affiche leurs alertes et donne
 * accès aux écrans détaillés de l'installation sélectionnée.
 * @typedef {Object} HomeProps
 * @property {import('../../../Models/DomainTypes').PayStation[]} filteredPayStations Installations visibles après filtrage.
 * @property {{ accountId: number }} currentUser Utilisateur courant fourni par Dashboard.
 * @property {{ graphql: (operation: object) => Promise<any> }} API
 * @property {string} locale
 * @property {boolean} isDarkStyle
 * @property {boolean} [isDesktop]
 * @property {object} [observer]
 * @property {(boxId: import('../../../Models/DomainTypes').EntityId) => void} onRequestedBoxOverview
 * @property {(boxId: import('../../../Models/DomainTypes').EntityId, deviceId: import('../../../Models/DomainTypes').EntityId) => void} onRequestedBoxDiagnostic
 * @property {(boxId: import('../../../Models/DomainTypes').EntityId, deviceId: import('../../../Models/DomainTypes').EntityId, level: number) => void} onRequestedMessages
 * @property {(boxId: import('../../../Models/DomainTypes').EntityId | null, operationType: number) => void} onRequestedOperations
 */

/** @extends {React.Component<HomeProps>} */
class Home extends React.Component {
    constructor( props ) {
        super( props );
        this.state = {
            selected: null,
            refresh: false,
            accounts: null
        }
        instanceHome = this;
    }

    componentDidUpdate( prevProps, prevState) {
        const changed = [];
        Object.keys( this.props ).forEach( key => {
            if ( this.props[key] !== prevProps[key] ) changed.push( 'prop:' + key );
        });
        Object.keys( this.state ).forEach( key => {
            if ( this.state[key] !== prevState[key] ) changed.push( 'state:' + key );
        });
        if ( changed.length ) console.log('[Home] re-render because of', changed.join(', ') );
    }

    loadAccounts() {
        if( this.props.API ) {
            this.props.API
                .graphql({ query: getDetailedAccounts, variables: { accountId: this.props.currentUser.accountId }})
                .then( rawAccounts => {
                    const tool = new GraphQlTool( 'getDetailedAccounts' , rawAccounts );
                    this.setState( { accounts: tool.extract() } );
                })
                .catch((error) => {
                    console.error("error" , error);
                })
        }
    }

    onNewState( state ) {
        //commented because too many renders on Cashmag account
        //instanceHome.setState({ refresh: !instanceHome.state.refresh }) ;
    }

    /** @param {import('../../../Models/DomainTypes').PayStation} payStation */
    handleSelection( payStation ) {
        instanceHome.setState({ selected: payStation }) ;
    }

    render() {
        if( ! this.state.accounts ) {
            this.loadAccounts();
        }

        const alerts = TechnicalAlertIdentifier.fetchAlerts( this.props.filteredPayStations );
        return (
            <React.Fragment>
                <Grid container spacing={1} className="main-lines">
                    <Grid item xs={12} md={12} lg={7} className={`installation-state-monitoring`}>
                        <InstallationStateMonitoring payStations={this.props.filteredPayStations}
                                                     onSelection={this.handleSelection}
                                                     selected={this.state.selected}
                                                     locale={this.props.locale} />
                    </Grid>
                    <Grid item xs={12} md={12} lg={5} className={`display ${this.props.isDarkStyle ? 'dark' : ''}`}>
                        <Grid item xs={12} md={12} lg={12} className={`technical-alert`}>
                            <TechnicalAlerts alerts={ alerts }
                                             isDarkStyle={this.props.isDarkStyle}
                                             onSelection={this.handleSelection}/>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12} className={`installation-display`}>
                            <InstallationQuickDisplay selected={this.state.selected}
                                                      API={this.props.API}
                                                      accounts={this.state.accounts}
                                                      alerts={ alerts }
                                                      onRequestedBoxOverview={this.props.onRequestedBoxOverview}
                                                      onRequestedBoxDiagnostic={this.props.onRequestedBoxDiagnostic}
                                                      onRequestedMessages={this.props.onRequestedMessages}
                                                      onRequestedOperations={this.props.onRequestedOperations}
                                                      isDarkStyle={this.props.isDarkStyle} />
                        </Grid>
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

export default Home;
